module.exports = __webpack_public_path__ + "media/Acess_Ok.c3a09e9b.ogg";